import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Services from "@/components/site/Services";
import HowItWorks from "@/components/site/HowItWorks";
import Faq from "@/components/site/Faq";
import Booking from "@/components/site/Booking";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <WhyChooseUs />
      <Services />
      <HowItWorks />
      <Faq />
      <Booking />
      <Contact />
      <Footer />
    </main>
  );
}
